import { api } from "@/lib/api";

// Maps a sidebar route to the backend GET endpoints its page loads first.
// Hovering a nav item warms these into the cache so the page renders instantly on click.
// tbmId is the currently selected machine (may be undefined before one is picked).
const ROUTE_ENDPOINTS = {
  "/": (id) => ["/company", "/stock/summary", ...(id ? [`/consumed/summary?period=monthly&tbm_id=${id}`] : [])],
  "/daily-logs": (id) => (id ? [`/daily-logs?tbm_id=${id}&limit=500&skip=0`] : []),
  "/equipment": (id) => (id ? [`/equipment?tbm_id=${id}`] : []),
  "/checklists": () => ["/checklists"],
  "/checklist-records": (id) => (id ? [`/checklist-instances?tbm_id=${id}`] : []),
  "/parts": () => ["/parts"],
  "/consumption": () => ["/tbms", "/consumed"],
  "/stock": () => ["/stores", "/stock/summary"],
  "/health": (id) => (id ? [`/health/logs?tbm_id=${id}`, `/machine-hours?tbm_id=${id}`] : []),
  "/daily-reports": (id) => (id ? [`/daily-reports/list?tbm_id=${id}`] : []),
  "/calendar": (id) => (id ? [`/calendar?tbm_id=${id}`] : []),
  "/job-site-pictures": () => ["/console/files"],
};

export function prefetchRouteData(path, tbmId) {
  const build = ROUTE_ENDPOINTS[path];
  if (!build) return;
  for (const p of build(tbmId)) api.prefetch(p);
}
